import { useEffect, useState } from "react";
import Modal from "../../../layouts/Modal";
import LoadingWheel from "../LoadingWheel";
import { ButtonInput } from "../Inputs/ButtonInput";
import { UseMutationResult } from "@tanstack/react-query";

import { useSearchParams } from 'react-router-dom';
import { set } from "lodash";

interface StripeValidateModalProps {
    mutation: UseMutationResult<any, unknown, any, unknown>;
}

export default function StripeValidateModal({
    mutation,
}: StripeValidateModalProps) {
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [failed, setFailed] = useState(false);
    const [shouldMutate, setShouldMutate] = useState(false);

    const [searchParams] = useSearchParams();

    useEffect(() => {
        const sessionId = searchParams.get("session_id");
        const success   = searchParams.get("success");

        if (sessionId && success) {
            if (success === "false") setFailed(true);
            else setShouldMutate(true);
            setOpen(true);
        } 
    }, [searchParams]);

    useEffect(() => {
        if (shouldMutate) validatePayment();
    }, [shouldMutate]);

    const validatePayment = () => {
        if (isLoading) return;

        setIsLoading(true);
        mutation.mutate(
            {sessionId: searchParams.get("session_id")},
            {
                onSuccess: (data) => {
                    console.log("Payment validated:", data);
                    // Handle success, e.g., show a success message or redirect.
                    setOpen(false);
                },
                onError: (error) => {
                    console.error("Payment validation error:", error);
                    setFailed(true);
                    // Handle error, e.g., show an error message.
                },
                onSettled: () => {
                    setIsLoading(false);
                },
            }
        );
    };

    if (isLoading) {
        return (
            <Modal open={open || isLoading} setOpen={setOpen} width={"max-w-lg"}>
                <div className="py-10">
                    <LoadingWheel />
                </div>
            </Modal>
        );
    }

    if (failed) {
        return (
            <Modal open={open} setOpen={setOpen} width={"max-w-lg"}>
                <div className="flex flex-col items-center justify-center p-4">
                    <h2 className="text-lg font-bold">Payment Failed</h2>
                    <div className="border border-b border-b-gray-300 w-full my-4"></div>
                    <p>Payment validation failed. Please try again.</p>
                </div>
            </Modal>
        );
    }

    return (
        <Modal open={open} setOpen={setOpen} width={"max-w-lg"}>
            <div className="flex flex-col items-center justify-center p-4">
                <h2 className="text-lg font-bold">Validating Payment</h2>
                <div className="border border-b border-b-gray-300 w-full my-4"></div>
                <p>Please wait while we validate your payment!</p>
            </div>
        </Modal>
    );
}